import React from 'react'

export function SectionHeader({title}) {
  return (
    <div className="section-header">{title}</div>
  )
}